export default __webpack_public_path__ + "static/media/sim.f8d38479.svg";